import { getUseRecommendationsByPartyQKey } from '@parties/src/features/detail/api/getRecommendationsByParty';
import cogoToast from 'cogo-toast';
import { useTranslation } from 'react-i18next';
import { useMutation, useQueryClient } from 'react-query';
import { useLocale } from '../../../../../../i18n';
import { Recommendations } from '../../../../../../types/Recommendations';
import { wgApi } from '../../../../../app/src/features/api/wgApi';

interface Params {
  partyId: string;
  userLang: string;
  userCountry: string;
  version?: string;
}

const createRecommendationsByParty = async ({
  partyId,
  userLang,
  userCountry,
  version,
}: Params) => {
  const { data, isError } = await wgApi.post<Recommendations>(
    `/v1/api/parties/${partyId}/insurance-recommendations`,
    {
      products_version: version,
    },
    { query: { country: userCountry, lang: userLang } },
  );
  if (isError) throw new Error();
  return data;
};

export const useCreateRecommendationByParty = () => {
  const { t } = useTranslation();
  const queryClient = useQueryClient();
  const { userLang, userCountry } = useLocale();

  return useMutation(
    (partyId: string) =>
      createRecommendationsByParty({
        partyId,
        userLang,
        userCountry,
        version: 'V2',
      }),
    {
      onError: () => {
        cogoToast.error(t('Something went wrong'), {
          hideAfter: 5,
        });
      },
      onSettled: (_, __, partyId) => {
        const queryKeyParties = getUseRecommendationsByPartyQKey({
          partyId,
        });
        queryClient.invalidateQueries(queryKeyParties);
      },
    },
  );
};
